export default __webpack_public_path__ + "static/media/photo--sm--blitz2.4251b96a.jpg";